import {
  faBriefcase,
  faBuilding,
  faHouse,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import "./AddNewAddress.css";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
// import Confirm_Location_modal from "../../common/Common_Modal/Confirm_Location_modal/Confirm_Location_modal";
import Your_Location_Info_Modal from "../../common/modals/Your_Location_Info_Modal/Your_Location_Info_Modal";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Light_Black_Btn from "../../common/common_btn/light_black_btn/Light_Black_Btn";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import {
  createOrderAddress,
  EditOrderAddress,
  getSingleOrderAddress,
} from "../../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import {
  AllArea,
  AllCity,
  AllCountry,
  AllPincode,
  AllState,
} from "../../../features/admin/common/Slice";
import { getLocationFromSession } from "../../../features/location/locationSlice";
import Cookies from "js-cookie";
const AddNewAddress = ({ addressId, setAddressId }) => {
  const [showModal, setShowModal] = useState(false);

  const [searchParams] = useSearchParams();
  const addressID = searchParams.get("addressID");
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [activeBtn, setActiveBtn] = useState(IDS.addressTypes.Home);
  const dispatch = useDispatch();
  const [isUpdate, setIsUpdate] = useState();

  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);
  const cities = useSelector((state) => state.common.all_city);
  const pincodes = useSelector((state) => state.common.all_pincode);
  const areas = useSelector((state) => state.common.all_area);

  const getSingleAddress = async () => {
    const res = await dispatch(getSingleOrderAddress({ id: addressID }));
    // console.log({ res });

    if (res.meta?.requestStatus === "fulfilled") {
      reset(res.payload?.data);
      setIsUpdate(true);
      setActiveBtn(res.payload?.data?.address_type_id);
    } else if (res.meta?.requestStatus === "rejected") {
      setIsUpdate(false);
    }
  };

  const handleCityChange = (selectedOption) => {
    console.log(selectedOption, "handleCityChange");
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    console.log(selectedOption, "handlePincodeChange");
    setValue("pincode_id", selectedOption?.value);
    setValue("area_id", null);

    dispatch(AllArea({ pincodeId: selectedOption.value }));
  };

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);

  useEffect(() => {
    if (addressID) {
      setIsUpdate(true);
      getSingleAddress();
    }
  }, [dispatch, addressID]);

  const response = Cookies.get("current_location_omtapovan");
  const [current_location, setCurrentLocation] = useState(null);

  useEffect(() => {
    if (response) {
      const data = JSON.parse(response);
      setCurrentLocation(data);
      setValue("street", current_location?.formatted_address);
    }
  }, [current_location]);


  const onSubmit = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("address_type_id", activeBtn);
    DataToSend.append("country_id", data?.country_id?.value);
    DataToSend.append("state_id", data?.state_id?.value);

    DataToSend.append(
      "lat",
      current_location?.geometry?.location?.lat ||
      current_location?.coordinates?.lat
    );
    DataToSend.append(
      "long",
      current_location?.geometry?.location?.lng ||
      current_location?.coordinates?.lng
    );

    DataToSend.append("city_id", data?.city_id?.value);
    DataToSend.append("pincode_id", data?.pincode_id?.value);
    DataToSend.append("area_id", data?.area_id?.value);
    DataToSend.append("building", data?.building);
    DataToSend.append("apartment", data?.apartment); //society
    DataToSend.append("area", data?.area);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("street", data?.street);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("floor", data?.floor);
    DataToSend.append("direction", data?.direction);

    DataToSend.append("socity_name", data?.socity_name);

    const res = await dispatch(createOrderAddress({ data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      navigate("/saved-address");
      setIsUpdate(false);
      reset();
    } else if (res.meta?.requestStatus === "rejected") {
      setIsUpdate(false);
      if (res.payload?.errors) {
        setError("building", {
          type: "manual",
          message: res.payload?.errors,
        });
      }
    }
  };

  const handleUpdate = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("address_type_id", activeBtn);
    DataToSend.append("country_id", data?.country_id?.value);
    DataToSend.append("state_id", data?.state_id?.value);
    DataToSend.append("city_id", data?.city_id?.value);
    DataToSend.append("pincode_id", data?.pincode_id?.value);
    DataToSend.append("area_id", data?.area_id?.value);
    DataToSend.append("building", data?.building);
    DataToSend.append("apartment", data?.apartment); //society
    DataToSend.append("area", data?.area);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("street", data?.street);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("floor", data?.floor);
    DataToSend.append("direction", data?.direction);

    DataToSend.append("socity_name", data?.socity_name);

    const res = await dispatch(EditOrderAddress({ id: addressID, data: DataToSend }));
    // console.log({ EditOrderAddress: res });
    if (res.meta?.requestStatus === "fulfilled") {
      setIsUpdate(false);
      navigate("/saved-address");
      reset();
    } else if (res.meta?.requestStatus === "rejected") {
      setIsUpdate(false);
      if (res.payload?.errors) {
        setError("building", {
          type: "manual",
          message: res.payload?.errors,
        });
      }
    }
  };

  // const current_location = useSelector(
  //   (state) => state?.location?.current_location
  // );

  // console.log(current_location,"current_location current_location");

  // useEffect(() => {
  //   dispatch(getLocationFromSession());
  // }, [dispatch]);

  return (
    <section className="AddNewAddress">
      <div className="container">
        <div className="add_new_address_main_div">
          <div className="data_holder">
            <div className={"map-section"}>
              <div className="mapouter">
                <div className="gmap_canvas">
                  <iframe
                    className="gmap_iframe"
                    src={`https://maps.google.com/maps?q=${current_location?.geometry?.location?.lat},${current_location?.geometry?.location?.lng}&hl=en&z=14&output=embed`}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                  <a href="https://pdflist.com/" alt="pdflist.com"></a>
                </div>
              </div>
              <div className={"overlaycolor"}></div>

              <div className="area_main_div">
                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="location_icon"
                  />
                </div>

                <div className="area_div">
                  <p className="area_heading">Area</p>
                  <div className="footer_text">
                    <div className="">
                      <p className="city_name">
                        {current_location?.formatted_address}
                      </p>
                    </div>

                    <div
                      className="right_side_text"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      <p className="green_text_underline">Change</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="address_form_main_div">
              <div className="address_type_btn_holder">
                <div
                  className={`address_type_btn ${activeBtn === IDS.addressTypes.Apartment ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveBtn(IDS.addressTypes.Apartment);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBuilding} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Apartment</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${activeBtn === IDS.addressTypes.Home ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveBtn(IDS.addressTypes.Home);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faHouse} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>House</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${activeBtn === IDS.addressTypes.Work ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveBtn(IDS.addressTypes.Work);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBriefcase} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Office</p>
                  </div>
                </div>
              </div>

              <Form className="form_div">
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Control
                      type="text"
                      name="building"
                      placeholder={
                        activeBtn === 1
                          ? "House name*"
                          : activeBtn === 2
                            ? "Apartment name*"
                            : "Office Name*"
                      }
                      {...register("building", {
                        required:
                          activeBtn === 1
                            ? "Building name required"
                            : activeBtn === 2
                              ? "Apartment Name required"
                              : "Office Name required",
                      })}
                    />
                    {errors?.building && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.building?.message}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <Form.Control
                      type="text"
                      name="apartment"
                      placeholder={
                        activeBtn === 1
                          ? "House no.*"
                          : activeBtn === 2
                            ? "Apartment No*"
                            : "Office No*"
                      }
                      {...register("apartment", {
                        // required:
                        //   activeBtn === 1
                        //     ? "House no. required"
                        //     : activeBtn === 2
                        //     ? "Apartment required"
                        //     : "Office No required",
                      })}
                    />
                    {errors?.apartment && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.apartment?.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-md-6  mb-3">
                    <Form.Control
                      type="text"
                      name="floor"
                      placeholder="Floor*"
                      {...register("floor", {
                        // required: "Floor required",
                      })}
                    />
                    {errors?.floor && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.floor?.message}
                      </div>
                    )}
                  </div>
                  {/* <div className="col-lg-6 col-md-6  mb-3">
                    <Form.Control
                      type="text"
                      name="area"
                      placeholder="Area Name"
                      {...register("area", {
                        // required: "Area Name required",
                      })}
                    />
                    {errors?.area && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.area?.message}
                      </div>
                    )}
                  </div> */}
                </div>

                <div className="row">
                  <div className="col-12 mb-3">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      type="text"
                      name="street"
                      placeholder="Street*"
                      {...register("street", {
                        required: "Street name required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.street,
                        "is-valid": getValues("street"),
                      })}
                    />
                    {errors?.street && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.street?.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Control
                      type="text"
                      name="direction"
                      placeholder="Additional directions (optional)"
                      {...register("direction", {
                        // required: "Additional directions are required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.direction,
                        "is-valid": getValues("direction"),
                      })}
                    />
                    {errors?.direction && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.direction?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Control
                      placeholder="Contact Number"
                      type="text"
                      name="contact_no"
                      maxLength={10} // restrict typing to 10 digits
                      {...register("contact_no", {
                        required: "Contact Number is required",
                        pattern: {
                          value: /^[0-9]+$/, // only numbers
                          message: "Only digits are allowed",
                        },
                        minLength: {
                          value: 10,
                          message: "Contact Number must be exactly 10 digits",
                        },
                        maxLength: {
                          value: 10,
                          message: "Contact Number must be exactly 10 digits",
                        },
                      })}
                    />

                    {errors?.contact_no && (
                      <Form.Text className="text-danger">
                        {errors.contact_no.message}
                      </Form.Text>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="country_id"
                      control={control}
                      rules={{ required: "Country is required" }}
                      render={({ field }) => (
                        <Select
                          placeholder="Select Country"
                          options={countries}
                          className="mb-3"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.country_id ? "red" : base,
                            }),
                          }}
                          {...field}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            setValue("state_id", null);
                            setValue("city_id", null);
                            setValue("pincode_id", null);
                            dispatch(
                              AllState({ countryId: selectedOption.value })
                            );
                          }}
                        />
                      )}
                    />
                    {errors.country_id && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.country_id.message}
                      </p>
                    )}
                  </div>

                  {/* STATE */}
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="state_id"
                      control={control}
                      rules={{ required: "State is required" }}
                      render={({ field }) => (
                        <Select
                          placeholder="Select State"
                          options={states}
                          className="mb-3"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.state_id ? "red" : base,
                            }),
                          }}
                          {...field}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            setValue("city_id", null);
                            setValue("pincode_id", null);
                            dispatch(
                              AllCity({ stateId: selectedOption.value })
                            );
                          }}
                        />
                      )}
                    />
                    {errors.state_id && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.state_id.message}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="city_id" // Form field name
                      control={control}
                      rules={{ required: "City is required" }}
                      render={({ field }) => (
                        <Select
                          noOptionsMessage={() => "City in this State"}
                          className="mb-3"
                          placeholder="Select City"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.city_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={cities}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption); // Update Controller's value
                            handleCityChange(selectedOption);
                            setValue("city_id", selectedOption);
                          }}
                        />
                      )}
                    />
                    {errors?.city_id && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.city_id?.message}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="pincode_id" // Form field name
                      control={control}
                      rules={{ required: "Pincode is required" }}
                      render={({ field }) => (
                        <Select
                          noOptionsMessage={() => "Pincode not available"}
                          className="mb-3"
                          placeholder="Select Pincode"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.pincode_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={pincodes}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption); // Update Controller's value
                            handlePincodeChange(selectedOption);
                            setValue("pincode_id", selectedOption);
                          }}
                        />
                      )}
                    />
                    {errors?.pincode_id && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.pincode_id?.message}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="area_id" // Form field name
                      control={control}
                      rules={{ required: "Area is required" }}
                      render={({ field }) => (
                        <Select
                          noOptionsMessage={() =>
                            "no Area Available in this Pincode"
                          }
                          className="mb-3"
                          placeholder="Select Area"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.area_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={areas}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption); // Update Controller's value
                            // handlePincodeChange(selectedOption);
                            // setValue("area_id", selectedOption);
                          }}
                        />
                      )}
                    />
                    {errors?.area_id && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.area_id?.message}
                      </div>
                    )}
                  </div>
                </div>
              </Form>

              <div className="text-center btn_holder">
                <div className="btndiv">
                  <Light_Black_Btn
                    btnText={"Cancel"}
                    onClick={() => {
                      navigate("/saved-address");
                    }}
                  />
                </div>
                <div className="btndiv">
                  {isUpdate ? (
                    <Pink_Btn
                      btnText={"Update Address"}
                      // onClick={() => {
                      // navigate("/saved-address");
                      // }}
                      onClick={handleSubmit(handleUpdate)}
                    />
                  ) : (
                    <Pink_Btn
                      btnText={"Save Address"}
                      // onClick={() => {
                      // navigate("/saved-address");
                      // }}
                      onClick={handleSubmit(onSubmit)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Your_Location_Info_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        // orange_btn_text={"Enter Address"}
        // green_btn_text={"Verify Address"}
        setCurrentLocation={setCurrentLocation}
        showText={false}
        modalTitle="Your Location Info"
      />
    </section>
  );
};

export default AddNewAddress;
// import {
//   faBriefcase,
//   faBuilding,
//   faHouse,
//   faLocationDot,
// } from "@fortawesome/free-solid-svg-icons";
// import "./AddNewAddress.css";
// import Select from "react-select";
// import React, { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Button, Form } from "react-bootstrap";
// import { Controller, useForm } from "react-hook-form";
// import classNames from "classnames";
// import PhoneInput from "react-phone-input-2";
// // import Confirm_Location_modal from "../../common/Common_Modal/Confirm_Location_modal/Confirm_Location_modal";
// import Your_Location_Info_Modal from "../../common/modals/Your_Location_Info_Modal/Your_Location_Info_Modal";
// import { useNavigate, useParams } from "react-router-dom";
// import Light_Black_Btn from "../../common/common_btn/light_black_btn/Light_Black_Btn";
// import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
// import { getSingleOrderAddress } from "../../../features/order/orderSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { IDS } from "../../../utils/IDS";
// import { AllPincode } from "../../../features/admin/common/Slice";

// const AddNewAddress = ({ addressId, setAddressId }) => {
//   const [showModal, setShowModal] = useState(false);

//   const { id } = useParams();

//   const navigate = useNavigate();

//   const {
//     control,
//     register,
//     handleSubmit,
//     getValues,
//     setError, setValue,
//     clearErrors,
//     formState: { errors },
//     reset,
//     trigger,
//   } = useForm();

//   const [activeBtn, setActiveBtn] = useState(IDS.addressTypes.Home);
//   const dispatch = useDispatch();
//   const [isUpdate, setIsUpdate] = useState();

//   const countries = useSelector((state) => state.common.all_country);
//   const states = useSelector((state) => state.common.all_state);
//   const cities = useSelector((state) => state.common.all_city);
//   const pincodes = useSelector((state) => state.common.all_pincode);

//   const getSingleAddress = async () => {
//     const res = await dispatch(getSingleOrderAddress({ id: id }));
//     console.log({ res });

//     if (res.meta?.requestStatus === "fulfilled") {
//       reset(res.payload?.data);
//       setActiveBtn(res.payload?.data?.address_type_id);
//     } else if (res.meta?.requestStatus === "rejected") {
//       // setIsUpdate(false);
//     }
//   };

//   const handleCityChange = (selectedOption) => {
//     console.log(selectedOption, "handleCityChange");

//     setValue("city_id", selectedOption?.value);
//     setValue("pincode_id", null);
//     dispatch(AllPincode({ cityId: selectedOption.value }));
//   };

//   const handlePincodeChange = (selectedOption) => {
//     console.log(selectedOption, "handlePincodeChange");
//     setValue("pincode_id", selectedOption?.value);
//   };

//   useEffect(() => {
//     if (id) {
//       setIsUpdate(true);
//     }
//     getSingleAddress();
//   }, [dispatch, id]);

//   return (
//     <section className="AddNewAddress">
//       <div className="container">
//         <div className="add_new_address_main_div">
//           <div className="data_holder">
//             <div className={"map-section"}>
//               <div className="mapouter">
//                 <div className="gmap_canvas">
//                   <iframe
//                     className="gmap_iframe"
//                     src="https://maps.google.com/maps?q=22.717837,75.884794&hl=en&z=14&output=embed"
//                     allowFullScreen=""
//                     loading="lazy"
//                   ></iframe>
//                   <a href="https://pdflist.com/" alt="pdflist.com"></a>
//                 </div>
//               </div>
//               <div className={"overlaycolor"}></div>

//               <div className="area_main_div">
//                 <div className="icon_holder">
//                   <FontAwesomeIcon
//                     icon={faLocationDot}
//                     className="location_icon"
//                   />
//                 </div>

//                 <div className="area_div">
//                   <p className="area_heading">Area</p>

//                   <div className="footer_text">
//                     <div className="">
//                       <p className="city_name">Kuwait City</p>
//                     </div>

//                     <div
//                       className="right_side_text"
//                       onClick={() => {
//                         setShowModal(true);
//                       }}
//                     >
//                       <p className="green_text_underline">Change</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="address_form_main_div">
//               <div className="address_type_btn_holder">
//                 <div
//                   className={`address_type_btn ${activeBtn === IDS.addressTypes.Apartment ? "active" : ""
//                     }`}
//                   onClick={() => {
//                     setActiveBtn(IDS.addressTypes.Apartment);
//                   }}
//                 >
//                   <div className="icon_holder">
//                     <FontAwesomeIcon icon={faBuilding} className="type_icon" />
//                   </div>

//                   <div className="address_type">
//                     <p>Apartment</p>
//                   </div>
//                 </div>

//                 <div
//                   className={`address_type_btn ${activeBtn === IDS.addressTypes.Home ? "active" : ""
//                     }`}
//                   onClick={() => {
//                     setActiveBtn(IDS.addressTypes.Home);
//                   }}
//                 >
//                   <div className="icon_holder">
//                     <FontAwesomeIcon icon={faHouse} className="type_icon" />
//                   </div>

//                   <div className="address_type">
//                     <p>House</p>
//                   </div>
//                 </div>

//                 <div
//                   className={`address_type_btn ${activeBtn === IDS.addressTypes.Work ? "active" : ""
//                     }`}
//                   onClick={() => {
//                     setActiveBtn(IDS.addressTypes.Work);
//                   }}
//                 >
//                   <div className="icon_holder">
//                     <FontAwesomeIcon icon={faBriefcase} className="type_icon" />
//                   </div>

//                   <div className="address_type">
//                     <p>Office</p>
//                   </div>
//                 </div>
//               </div>

//               <Form className="form_div">
//                 <div className="row">
//                   <div className="col-lg-6 col-md-6">
//                     {activeBtn === IDS.addressTypes.Home ? (
//                       <Form.Control
//                         type="text"
//                         name="building"
//                         placeholder="Building name*"
//                         {...register("building", {
//                           required: "Building name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.building,
//                           "is-valid": getValues("building"),
//                         })}
//                       />
//                     ) : (
//                       <Form.Control
//                         type="text"
//                         name="Building"
//                         placeholder="Building name*"
//                         {...register("building", {
//                           required: "Building name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.building,
//                           "is-valid": getValues("building"),
//                         })}
//                       />
//                     )}
//                   </div>
//                   <div className="col-lg-6 col-md-6">
//                     {activeBtn === IDS.addressTypes.Apartment ? (
//                       <Form.Control
//                         type="text"
//                         name="Apartment"
//                         placeholder="Society name*"
//                         {...register("apartment", {
//                           required: "First name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.apartment,
//                           "is-valid": getValues("apartment"),
//                         })}
//                       />
//                     ) : (
//                       <Form.Control
//                         type="text"
//                         name="building"
//                         placeholder="Building Name"
//                         {...register("building", {
//                           required: "Building name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.building,
//                           "is-valid": getValues("building"),
//                         })}
//                       />
//                     )}
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-lg-6 col-md-6">
//                     {activeBtn === IDS.addressTypes.Apartment ? (
//                       <Form.Control
//                         type="text"
//                         name="Floor"
//                         placeholder="Floor"
//                         {...register("floor", {
//                           required: "Floor required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.floor,
//                           "is-valid": getValues("floor"),
//                         })}
//                       />
//                     ) : activeBtn === IDS.addressTypes.Home ? (
//                       <Form.Control
//                         type="text"
//                         name="floor"
//                         placeholder="Floor*"
//                         {...register("floor", {
//                           required: "floor required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.floor,
//                           "is-valid": getValues("floor"),
//                         })}
//                       />
//                     ) : (
//                       <Form.Control
//                         type="text"
//                         name="First_Name"
//                         placeholder="Company Name*"
//                         {...register("first_name", {
//                           required: "First name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.first_name,
//                           "is-valid": getValues("first_name"),
//                         })}
//                       />
//                     )}
//                   </div>
//                   <div className="col-lg-6 col-md-6">
//                     {activeBtn === IDS.addressTypes.Apartment ? (
//                       <div className="row">
//                         <div className="col-lg-6">
//                           <Form.Control
//                             type="text"
//                             name="apartment"
//                             placeholder="Apt. no.*"
//                             {...register("apartment", {
//                               required: "First name required",
//                             })}
//                             className={classNames("", {
//                               "is-invalid": errors?.apartment,
//                               "is-valid": getValues("apartment"),
//                             })}
//                           />
//                         </div>
//                         <div className="col-lg-6">
//                           <Form.Control
//                             type="text"
//                             name="floor"
//                             placeholder="Floor*"
//                             {...register("floor", {
//                               required: "floor required",
//                             })}
//                             className={classNames("", {
//                               "is-invalid": errors?.floor,
//                               "is-valid": getValues("floor"),
//                             })}
//                           />
//                         </div>
//                       </div>
//                     ) : activeBtn === IDS.addressTypes.Home ? (
//                       <Form.Control
//                         type="text"
//                         name="street"
//                         placeholder="Street*"
//                         {...register("street", {
//                           required: "street required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.street,
//                           "is-valid": getValues("street"),
//                         })}
//                       />
//                     ) : (
//                       <Form.Control
//                         type="text"
//                         name="Floor"
//                         placeholder="Floor"
//                         {...register("floor", {
//                           required: "First name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.floor,
//                           "is-valid": getValues("floor"),
//                         })}
//                       />
//                     )}
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-lg-6 col-md-6">
//                     {activeBtn === IDS.addressTypes.Apartment ? (
//                       <Form.Control
//                         type="text"
//                         name="Street"
//                         placeholder="Street"
//                         {...register("street", {
//                           required: "Street required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.street,
//                           "is-valid": getValues("street"),
//                         })}
//                       />
//                     ) : activeBtn === IDS.addressTypes.Home ? (
//                       <Form.Control
//                         type="text"
//                         name="direction"
//                         placeholder="Additional directions (optional)"
//                         {...register("direction", {
//                           required: "direction required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.direction,
//                           "is-valid": getValues("direction"),
//                         })}
//                       />
//                     ) : (
//                       <Form.Control
//                         type="text"
//                         name="Street"
//                         placeholder="Street*"
//                         {...register("street", {
//                           required: "Street required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.street,
//                           "is-valid": getValues("street"),
//                         })}
//                       />
//                     )}
//                   </div>
//                   <div className="col-lg-6 col-md-6">
//                     {activeBtn === IDS.addressTypes.Home ? (
//                       <>
//                         <Controller
//                           className="phone_input"
//                           name="contact_no"
//                           control={control}
//                           rules={{
//                             required: "contact_no is required",
//                             minLength: {
//                               value: 10,
//                               message:
//                                 "Number should be at least 10 characters",
//                             },
//                           }}
//                           render={({ field }) => (
//                             <PhoneInput
//                               country="in"
//                               {...field}
//                               className={classNames("", {
//                                 "is-invalid": errors?.contact_no,
//                                 "is-valid": getValues("contact_no"),
//                               })}
//                               onChange={(value) => field.onChange(value)}
//                               type="text"
//                               placeholder="Enter Mobile Number"
//                               maxLength={10}
//                             />
//                           )}
//                         />

//                         <p className="green_text_underline">Add Contact</p>
//                       </>
//                     ) : (
//                       <Form.Control
//                         type="text"
//                         name="Direction"
//                         placeholder="Additional directions (optional)"
//                         {...register("direction", {
//                           required: "First name required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.direction,
//                           "is-valid": getValues("direction"),
//                         })}
//                       />
//                     )}
//                   </div>
//                 </div>

//                 {activeBtn === IDS.addressTypes.Home ? null : (
//                   <div className="row">
//                     <div className="col-lg-6 col-md-6">
//                       <Controller
//                         className="phone_input"
//                         name="contact_no"
//                         control={control}
//                         rules={{
//                           required: "contact_no is required",
//                           minLength: {
//                             value: 10,
//                             message: "Number should be at least 10 characters",
//                           },
//                         }}
//                         render={({ field }) => (
//                           <PhoneInput
//                             country="in"
//                             {...field}
//                             className={classNames("", {
//                               "is-invalid": errors?.contact_no,
//                               "is-valid": getValues("contact_no"),
//                             })}
//                             onChange={(value) => field.onChange(value)}
//                             type="text"
//                             placeholder="Enter Mobile Number"
//                             maxLength={10}
//                           />
//                         )}
//                       />
//                     </div>

//                     <div className="row">
//                       <div className="col-lg-6 col-md-6">
//                         <p className="green_text_underline">Add Contact</p>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 <div className="row">
//                   <div className="col-lg-6 col-md-6 mb-3">
//                     <Controller
//                       className="Select_Dropdown_holder"
//                       name="city_id" // Form field name
//                       control={control}
//                       rules={{ required: "City is required" }}
//                       render={({ field }) => (
//                         <Select
//                           className="mb-3"
//                           placeholder="Select City"
//                           styles={{
//                             control: (baseStyles) => ({
//                               ...baseStyles,
//                               borderColor: errors.city_id ? "red" : baseStyles,
//                             }),
//                           }}
//                           {...field}
//                           options={cities}
//                           onChange={(selectedOption) => {
//                             field.onChange(selectedOption.value); // Update Controller's value
//                             handleCityChange(selectedOption);
//                             setValue("city_id", selectedOption);
//                           }}
//                         />
//                       )}
//                     />
//                     {errors?.city_id && (
//                       <div style={{ fontSize: "13px", color: "red" }}>
//                         {errors?.city_id?.message}
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-lg-6 col-md-6 mb-3">
//                     <Controller
//                       className="Select_Dropdown_holder"
//                       name="pincode_id" // Form field name
//                       control={control}
//                       rules={{ required: "Pincode is required" }}
//                       render={({ field }) => (
//                         <Select
//                           className="mb-3"
//                           placeholder="Select Pincode"
//                           styles={{
//                             control: (baseStyles) => ({
//                               ...baseStyles,
//                               borderColor: errors.pincode_id
//                                 ? "red"
//                                 : baseStyles,
//                             }),
//                           }}
//                           {...field}
//                           options={pincodes}
//                           onChange={(selectedOption) => {
//                             field.onChange(selectedOption.value); // Update Controller's value
//                             handlePincodeChange(selectedOption);
//                             setValue("pincode_id", selectedOption);
//                           }}
//                         />
//                       )}
//                     />
//                     {errors?.pincode_id && (
//                       <div style={{ fontSize: "13px", color: "red" }}>
//                         {errors?.pincode_id?.message}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </Form>

//               <div className="text-center btn_holder">
//                 <div className="btndiv">
//                   <Light_Black_Btn
//                     btnText={"Cancel"}
//                     onClick={() => {
//                       navigate("/saved-address");
//                     }}
//                   />
//                 </div>
//                 <div className="btndiv">
//                   <Pink_Btn
//                     btnText={"Save Address"}
//                     onClick={() => {
//                       navigate("/saved-address");
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Your_Location_Info_Modal

//         show={showModal}
//         onHide={() => setShowModal(false)}
//         // orange_btn_text={"Enter Address"}
//         // green_btn_text={"Verify Address"}
//         showText={false}
//         modalTitle="Your Location Info"
//       />
//     </section>
//   );
// };

// export default AddNewAddress;
